export default defineNuxtPlugin(() => {
  // Development previews can run on a different port than the default server.
  // Production keeps the configured public site URL for generated image URLs.
  if (import.meta.dev) {
    updateSiteConfig({ url: useRequestURL().origin })
  }
})
